import React, { useState } from 'react';
import { Calendar as CalendarIcon, Clock, User, Car } from 'lucide-react';
import { Calendar } from '../components/ui/Calendar';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { mockAppointments, mockClients, mockVehicles } from '../data/mockData';
import { formatDateTime } from '../lib/utils';
import { Badge } from '../components/ui/Badge';
export function Schedule() {
  const [date, setDate] = useState<Date | undefined>(new Date());
  return <div className="h-full flex flex-col space-y-6" data-id="element-799">
      <div data-id="element-800">
        <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-801">
          Agenda
        </h1>
        <p className="text-muted-foreground mt-1" data-id="element-802">
          Gerencie os agendamentos da oficina.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 flex-1 overflow-hidden" data-id="element-803">
        <Card className="w-full lg:w-auto h-fit" data-id="element-804">
          <CardContent className="p-3" data-id="element-805">
            <Calendar mode="single" selected={date} onSelect={setDate} className="rounded-md" data-id="element-806" />
          </CardContent>
        </Card>

        <Card className="flex-1 flex flex-col overflow-hidden" data-id="element-807">
          <CardHeader data-id="element-808">
            <CardTitle data-id="element-809">Agendamentos do Dia</CardTitle>
          </CardHeader>
          <CardContent className="flex-1 overflow-auto space-y-4" data-id="element-810">
            {mockAppointments.map(apt => {
            const client = mockClients.find(c => c.id === apt.clientId);
            const vehicle = mockVehicles.find(v => v.id === apt.vehicleId);
            return <div key={apt.id} className="flex gap-4 p-4 rounded-xl border bg-card hover:border-primary/50 transition-colors" data-id="element-811">
                  <div className="flex flex-col items-center justify-center px-4 border-r border-border" data-id="element-812">
                    <Clock className="h-5 w-5 text-primary mb-1" data-id="element-813" />
                    <span className="font-bold text-lg" data-id="element-814">
                      {new Date(apt.date).toLocaleTimeString('pt-BR', {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-815">
                    <div className="flex items-center justify-between mb-2" data-id="element-816">
                      <h4 className="font-semibold text-lg" data-id="element-817">{apt.notes}</h4>
                      <Badge variant="outline" className={apt.status === 'confirmed' ? 'bg-emerald-500/10 text-emerald-500' : apt.status === 'scheduled' ? 'bg-blue-500/10 text-blue-500' : ''} data-id="element-818">
                        {apt.status === 'confirmed' ? 'Confirmado' : 'Agendado'}
                      </Badge>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground" data-id="element-819">
                      <div className="flex items-center gap-2" data-id="element-820">
                        <User className="h-4 w-4" data-id="element-821" /> {client?.name}
                      </div>
                      <div className="flex items-center gap-2" data-id="element-822">
                        <Car className="h-4 w-4" data-id="element-823" /> {vehicle?.brand}{' '}
                        {vehicle?.model} ({vehicle?.plate})
                      </div>
                    </div>
                  </div>
                </div>;
          })}

            {mockAppointments.length === 0 && <div className="h-full flex flex-col items-center justify-center text-muted-foreground" data-id="element-824">
                <CalendarIcon className="h-12 w-12 mb-4 opacity-20" data-id="element-825" />
                <p data-id="element-826">Nenhum agendamento para esta data.</p>
              </div>}
          </CardContent>
        </Card>
      </div>
    </div>;
}